import axionIns from "../axios";

const post = async (url, payload) => {
  return await axionIns
    .post(url, JSON.stringify(payload))
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return response;
    });
};

const get = async (url) => {
  return axionIns
    .get(url)
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return response;
    });
};

const put = async (url, payload) => {
  return axionIns
    .put(url, JSON.stringify(payload))
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return response;
    });
};

const patchApi = async (url, payload) => {
  return axionIns
    .patch(url, JSON.stringify(payload))
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return response;
    });
};

const deleteApi = async (url, payload) => {
  return axionIns
    .delete(url, payload)
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return response;
    });
};

const exportObject = {
  post,
  get,
  put,
  patchApi,
  deleteApi,
};
export default exportObject;
